export { default as PaginationDots } from './PaginationDots'
export type { PaginationDotsProps } from './types'
export { PaginationDotsVariant } from './types'
